import logo from "../logo.png";

const Header = () => {
    return <header className="header">
        <img src={logo} className="logo" alt="Wessex Garages" />
    </header>;
};

export default Header;
